export const SUCCESS_STATUS = "success";
export const ERROR_STATUS = "error";
export const LOADING_STATUS = "loading";
